import { Notify } from 'quasar'

function copied (message) {
  Notify.create({
    message: message,
    position: 'top'
  })
}

function download (response, fileName) {
  const href = URL.createObjectURL(response)

  // create "a" HTML element with href to file & click
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', fileName) // or any other extension
  document.body.appendChild(link)
  link.click()

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async ({ Vue }) => {
  Vue.prototype.$copied = copied
  Vue.prototype.$download = download
}
